import { render, staticRenderFns } from "./bareRootsFormPage.vue?vue&type=template&id=305e09f4&scoped=true&"
import script from "./bareRootsFormPage.vue?vue&type=script&lang=js&"
export * from "./bareRootsFormPage.vue?vue&type=script&lang=js&"
import style0 from "./bareRootsFormPage.vue?vue&type=style&index=0&id=305e09f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305e09f4",
  null
  
)

export default component.exports